import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'
import type { Service } from '@/api/typings/service.typing'

export function getServiceBySlugAction(slug: string): Promise<ApiResponse<Service>> {
  return api.v2.get<ApiResponse<Service>>(`/services/${slug}`)
}
